import { Helpers } from '@utils/helpers';
import { get, isEmpty } from 'lodash';

export class MyInfoForm {
  fullName: string;
  givname: string;
  surname: string;
  salutation: string;
  mobileNum: string;
  emailId: string;
  nric: string;
  dob: any;
  gender: string;
  nationality: string;
  race: string;
  postal: string;
  floor: string;
  unit: string;
  street: string;
  block: string;
  building: string;
  marital: string;
  public _extraAddress?: MyInfoAddressForm
  constructor(initial: any) {
    const fullName = get(initial, 'fullName', undefined)
    this.fullName = isEmpty(fullName) ? undefined : fullName;
    const givname = get(initial, 'givname', undefined);
    this.givname = isEmpty(givname) ? undefined : givname;
    const surname = get(initial, 'surname', undefined);
    this.surname = isEmpty(surname) ? undefined : surname;
    this.salutation = get(initial, 'salutation', undefined);
    const mobileNum = get(initial, 'mobileNum', undefined);
    this.mobileNum =  isEmpty(mobileNum) ? undefined : mobileNum;
    const emailId = get(initial, 'emailId', undefined);
    this.emailId = isEmpty(emailId) ? undefined : emailId;
    this.nric = get(initial, 'nric', undefined);
    this.gender = get(initial, 'gender', undefined);    
    this.nationality = get(initial, 'nationality', undefined);    
    this.race = get(initial, 'race', undefined);    
    this.postal = get(initial, 'postal', undefined);
    this.floor = get(initial, 'floor', undefined);
    this.unit = get(initial, 'unit', undefined);    
    this.street = get(initial, 'street', undefined);    
    this.block = get(initial, 'block', undefined);    
    this.building = get(initial, 'building', undefined);
    this.dob = get(initial, 'dob', undefined);
    this.marital = get(initial, 'marital', undefined);
  }

  get reviewPersonalDetails(): { text: string, value: string }[] {
    const stringDate = this.dob;
    return [
      { text: 'Full name (as per NRIC)', value: this.fullName || '' },
      { text: 'Family name', value: this.surname || '' },
      { text: 'Given name', value: this.givname || '' },
      { text: 'NRIC/FIN', value: this.nric || '' },
      { text: 'Gender', value: Helpers.getGenderNameByCode(this.gender || '') },
      { text: 'Nationality', value: Helpers.getNationalityByCode(this.nationality || '') },
      { text: 'Date of birth', value: stringDate ? Helpers.getStringDate(new Date(stringDate)): '' },
      { text: 'Marital status', value: Helpers.getMaritalByCode(this.marital || '') },
      { text: 'Race', value: Helpers.getRaceByCode(this.race || '') },
      { text: 'Postal code', value: this.postal || '' },
      { text: 'Unit', value: this.floor ? `${this.floor}-${this.unit}` : this.unit || '' },
      { text: 'Street', value: this.street || '' },
      { text: 'Block', value: this.block || '' },
      { text: 'Building name', value: this.building || '' },
    ]
  }

  get reviewOtherDetails(): { text: string, value: string }[] {
    const extra = this._extraAddress;
    const list =  [
      { text: 'Salutation', value: Helpers.getSalutationByCode(this.salutation) },
      { text: 'Mobile number', value: this.mobileNum || '' },
      { text: 'Email', value: this.emailId || '' },
      { text: 'Mailing address different from your residential address?', value: isEmpty(extra) ? 'No' : 'Yes' },
    ];
    if (!isEmpty(extra)) {
      list.push(
        { text: 'Postal code', value: get(extra, 'postcode', this.postal) },
        { text: 'Unit', value: get(extra, 'unit', this.unit) },
        { text: 'Street', value: get(extra, 'street', this.street) },
        { text: 'Block', value: get(extra, 'block', this.block) },
        { text: 'Building name (if any)', value: get(extra, 'building', this.building) },
      )
    }
    return list;
  }

  set extraAddress(value: any) {
    this._extraAddress = value;
  }
}

export class MyInfoAddressForm {
  postcode: string | undefined;
  block: string | undefined;
  unit: string | undefined;
  street: string | undefined;
  building: string | undefined;

  constructor(initial: any) {
    this.postcode = get(initial, 'postcode', undefined);
    this.block = get(initial, 'block', undefined);
    this.unit = get(initial, 'unit', undefined);
    this.street =  get(initial, 'street', undefined);
    this.building =  get(initial, 'building', undefined);
  }
}
export class AddMyInfoForm {
  l400Profile: string;
  uinfin: string;
  name: string;
  sex: string;
  race: string;
  otherRace: string;
  nationality: string;
  dob: any;
  email: string;
  mobileno: string;
  marital: string;
  postal: string;
  block: string;
  unit: string;
  street: string;
  building: string;
  givenName: string;
  familyName: string;
  salutation: string;
  
  isLannded?: boolean;
  constructor(initial: any) {
    this.l400Profile = get(initial, 'l400Profile', undefined);
    this.uinfin = get(initial, 'uinfin', undefined);
    this.name = get(initial, 'name', undefined);
    this.sex = get(initial, 'sex', undefined);
    this.race = get(initial, 'race', undefined);
    this.otherRace = get(initial, 'otherRace', undefined);
    this.nationality = get(initial, 'nationality', undefined);
    this.dob = get(initial, 'dob', { day: undefined, month: undefined, year: undefined });
    this.email = get(initial, 'email', undefined);
    this.mobileno = get(initial, 'mobileno', undefined);
    this.marital = get(initial, 'marital', undefined);
    this.postal = get(initial, 'postal', undefined);
    this.block = get(initial, 'block', undefined);
    this.unit = get(initial, 'unit', undefined);
    this.street = get(initial, 'street', undefined);
    this.building = get(initial, 'building', undefined);
    this.givenName = get(initial, 'givenName', undefined);
    this.familyName = get(initial, 'familyName', undefined);
    this.salutation = get(initial, 'salutation', undefined);
  }

  get person() {
    return {
      uinfin: { value: this.uinfin },
      name: { value: this.name },
      sex: { code: this.sex },
      race: { code: this.race },
      nationality: { code: this.nationality },
      dob: { value: `${this.dob.year}-${this.dob.month}-${this.dob.day}` },
      email: { value: this.email },
      mobileno: { nbr: { value: this.mobileno  }},
      marital: { code: this.marital },
      regadd: {
        unit: { value: this.unit },
        street: { value: this.street },
        block: { value: this.block },
        postal: { value: this.postal },
        building: { value: this.building }
      },
    }
  }
}